<template>
  <div class="show" v-if="showInfo">
    <div class="box">
      <div class="logo" @click="goHome">
        <h1>北京佰标</h1>
      </div>
      <div class="certificate">
        <div class="title">
          <h2 class="">企业牌匾查询结果</h2>
          <!-- <a class="down" @click="download()">电子证书下载</a> -->
          <router-link class="inquery" :to="$QueryPath">继续查询</router-link>
        </div>
        <div class="baseinfo">
          <ul>
            <li class="title">企业基本信息</li>
            <li>
              <span class="cname">企业名称</span>
              <span class="info">{{ showInfo.qiyename }}</span> 
            </li>
            <li>
              <span class="cname">社会信用代码</span>
              <span class="info">{{ showInfo.socialcreditcode }}</span>
            </li>
            <li>
              <span class="cname">法定代表人</span>
              <span class="info">{{ showInfo.legalperson }}</span>
            </li>
            <li>
              <span class="cname">企业类型</span>
              <span class="info">{{ showInfo.qiyetype }}</span>
            </li>
            <li class="bottom">
              <span class="cname">企业地址</span>
              <span class="info">{{ showInfo.address }}</span>
            </li>
          </ul>
        </div>
        <div class="cateinfo">
          <ul v-if="showInfo.code">
            <li class="title">牌匾基本信息</li>
            <li>
              <span class="cname">企业牌匾名称</span>
              <span class="info">{{ showInfo.certname.replace(/\//g,'') }}</span>
            </li>
            <li>
              <span class="cname">企业牌匾类型</span>
              <span class="info">{{ showInfo.certtype }}</span>
            </li>
            <li>
              <span class="cname">证书等级</span>
              <span class="info">{{ showInfo.certlevel }}</span>
            </li>
            <li>
              <span class="cname">证书编号</span>
              <span class="info">{{ showInfo.code }}</span>
            </li>
            <li>
              <span class="cname">发证日期</span>
              <span class="info">{{ showInfo.certdate }}</span>
            </li>
            <li>
              <span class="cname">有效日期</span>
              <span class="info">{{ showInfo.valieddate }}</span>
            </li>
            <li>
              <span class="cname">发证机关</span>
              <span class="info">{{ showInfo.regauth }}</span>
            </li>
            <li>
              <span class="cname">查询网址</span>
              <span class="info">{{ showInfo.regurl | upperFilter }}</span>
            </li>
            <li class="bottom">
              <span class="info">年审记录</span>
              <span :class="index == 2 ? 'ends' :'info'" v-for="(item,index) in showInfo.nianjian" :key="index">
                <img v-if="item" :src="`${IP_TEST}/uploads/${sealpicsrc}`" width="142" />
                <span>{{item}}</span>
              </span>
             </li>
          </ul>
          <ul v-else>
            <li class="title">证书基本信息</li>
            <li class="overdue">
              已过期
            </li>
          </ul>
        </div>
      </div>
      <div class="copyright">©CopyRight 2002-2020 版权所有</div>
    </div>
  </div>
</template>

<script>
/**
 * 企业牌匾查询系统模版
 */
import { IP_TEST } from '@/config';
export default {
  name: "ShowQypb",
  data() {
    return {
      IP_TEST
    }
  },
  computed: {
    sealpicsrc() {
      return localStorage.getItem('sealpicsrc');
    }
  },
  props: {
    showInfo: Object
  },
  methods: {
    goHome() {
      this.$router.push("/");
    }
  }
};
</script>
<style scoped>
.show{
  position: relative;
  width: 100%;
  height: 1522px;
  background: url(/static/img/inq/chaxun_bg1.png) no-repeat;
  background-size: auto;
}
.show>.box {
  position: relative;
  width: 1200px;
  margin: 0 auto;
  padding: 18px;
}
.box>.logo {
  position: relative;
  height: 104px;
  background: url(/static/img/inq/logo1.png) no-repeat;
  background-size: 511px 104px;
  overflow: hidden;
}

.box>.logo>h1 {
  position: absolute;
  left: -1116px;
}
.box>.certificate{
  position: relative;
  margin-top: 51px;
  width: 1200px;
  /* height: 1264px; */
  background: #FFFFFF;
  box-shadow: -1px 4px 18px 0px rgba(0, 170, 185, 0.41);
  overflow: hidden;
}
.box>.certificate>.title{
  margin: 38px 0 42px;
  height: 61px;
  display: flex;
  justify-content: end;
}
.box>.certificate>.title>h2{
  width: 532px;
  height: 61px;
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  text-align: center;
  line-height: 61px;
  background: url(/static/img/inq/biaoti_kug.png) no-repeat;
  background-size: 532px 61px;
}
.box>.certificate>.title>a.down{
  margin-left:89px;
  margin-right:46px;
  width: 102px;
  height: 61px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #5A94F1;
  line-height: 61px;
  text-align: center;
}
.box>.certificate>.title>a.inquery {
  margin-right: 27px;
  width: 68px;
  height: 61px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height: 61px;
  text-align: center;
}
.box>.certificate>.baseinfo>ul{
  margin-left: 30px;
  width: 1145px;
  height: 320px;
}
.cateinfo>ul{
  margin-top: 24px;
  margin-left: 30px;
  width: 1145px;
  height: 696px;
  background: url(/static/img/inq/hua_icon.png) no-repeat;
  background-size: 606px 545px;
  background-position:281px 87px;
}
.box>.certificate>.baseinfo>ul>li,.cateinfo>ul>li{
  width: 1141px;
  height: 50px;
  border-bottom:1px solid #F0F0F0;
  border-left:1px solid #D1D1D1;
  border-right:1px solid #D1D1D1;
  display: flex;
  justify-content: start;
}
.box>.certificate>.baseinfo>ul>li>span.cname,.cateinfo>ul>li>span.cname{
  display: inline-block;
  width: 123px;
  height: 50px;
  border-right: 1px solid #F0F0F0;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 50px;
  padding-left: 56px;
}
.cateinfo>ul>li.big{
  display: flex;
  justify-content: start;
  height: 93px;
}
.cateinfo>ul>li.big>.col{
  width: 961px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height: 46px;
}
.cateinfo>ul>li.big>.col>.one,.cateinfo>ul>li.big>.col>.two{
  width: 961px;
  height: 46px;
}
.cateinfo>ul>li.big>.col>.one{
  border-bottom: 1px solid #F0F0F0;
}
.cateinfo>ul>li.big>.col>.one>span,.cateinfo>ul>li.big>.col>.two>span{
  display: inline-block;
  padding-left: 57px;
  width: 180px;
}
.cateinfo>ul>li.big>.col>.one>span.inline,
.cateinfo>ul>li.big>.col>.two>span.inline {
  border-right:1px solid #F0F0F0;
}
.cateinfo>ul>li.big>span.cnameb{
  width: 123px;
  height: 91px;
  border-right: 1px solid #F0F0F0;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 91px;
  padding-left: 56px;
}
.box>.certificate>.baseinfo>ul>li>span.info,.cateinfo>ul>li>span.info{
  padding-left: 57px;
  display: inline-block;
  height: 50px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height: 50px;
}
.box>.certificate>.baseinfo>ul>li>span.line{
  width: 333px;
  border-right: 1px solid #F0F0F0;
}
.box>.certificate>.baseinfo>ul>li.bottom{
  border-bottom: 1px solid #D1D1D1;
  height: 53px;
  line-height: 53px;
}
.cateinfo>ul>li.bottom {
  border-bottom: 1px solid #D1D1D1;
  height: 95px;
  line-height: 95px;
  display: flex;
  justify-content: start;
}

.cateinfo>ul>li.bottom>span.info,.cateinfo>ul>li.bottom>span.ends {
  padding-left: 0;
  width: 284px;
  height: 95px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 95px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
}
.cateinfo>ul>li.overdue{
    border-bottom: 1px solid #D1D1D1;
    height: 634px;
    line-height: 634px;
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #666666;
    display: flex;
    justify-content: center;
    align-items: center;
}
.cateinfo>ul>li.bottom>span.info>span,.cateinfo>ul>li.bottom>span.ends>span{
  height: 24px;
  line-height: 24px;
}
.cateinfo>ul>li.bottom>span.info{
  border-right:1px solid #F0F0F0;
}

.box>.certificate>.baseinfo>ul>li.title,.cateinfo>ul>li.title{
  width: 1123px;
  height: 62px;
  padding-right: 20px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 62px;
  text-align: center;
  background: rgba(239, 244, 253, .1) url(/static/img/inq/icon_xiantiao.png) no-repeat;
  background-size: 1143px 62px;
  border: 0;
  justify-content: center;
}

.box>.copyright{
  position: relative;
  margin-top: 35px;
  margin-left: 501px;
  width: 219px;
  height: 13px;
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #303030;
  line-height: 13px;
}
</style>